import { render, staticRenderFns } from "./newDynamic.vue?vue&type=template&id=20da71ec&scoped=true"
import script from "./newDynamic.vue?vue&type=script&lang=js"
export * from "./newDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20da71ec",
  null
  
)

export default component.exports